module.exports = __webpack_public_path__ + "img/5.4bf250fa.svg";